'use strict';

/*
DOCUMENT ME
*/

define('modules/module.vehicleInfo.specific',[
  'jquery',
  './module',
  'txt!./module.static.hbs', // bad idea to use static as text?
  'txt!./module.loader.hbs',
  'lib/page-cache',
  'lib/services/lscs',
  'lib/util/tda.config',
  'modernizr',
  'lib/imgix',

  // side effect includes
  'textfit'
], function (
  $,
  Module,
  txtTemplate,
  txtModuleLoader,
  PageCache,
  lscs,
  tdaConfig,
  modernizr,
  imgix
) {
  var __tmplBody = Handlebars.compile(txtTemplate);
  var __tmplLoader = Handlebars.compile(txtModuleLoader);
  var __isMobile = !!modernizr.mobile;

  // kinda silly, PLUS just cause it's 2019 wouldn't mean BAT would have all of their /2018/ pages setup.
  // do we have a 'myco' year we can use instead of currentyear?
  var currYear = new Date().getFullYear();
  function __buildSeriesPath(series, year) {
    if (year !== currYear) {
      return series + '/' + year;
    }
    return series;
  }

  function __xformVehicleInfo(xmlData) {
    var vehicleInfo = {};
    var $data = $(xmlData).find('VehicleInfoModules > SeriesManager');
    vehicleInfo.image = {
      '1x1': imgix($data.find('image13').text(), { w: 310 }),
      '2x1': imgix($data.find('image23').text(), { w: 393 }),
      '3x1': imgix($data.find('image33').text(), { w: 636 })
    };
    vehicleInfo.subtext = $data.find('subtext').text();
    vehicleInfo.headline = $data.find('headline').text();
    vehicleInfo.copy = { '1x1': '<p>' + $data.find('bodytext').text() + '</p>' };
    return vehicleInfo;
  }

  var VehicleInfoSpecificModule = Module.extend({
    template: __tmplLoader,
    staticData: {
      all: {
        subtextIcon: '/assets/img/module/vehicleInfo/icon-vehicle-info.svg',
      },
      en: { actions: [] },
      es: { actions: [] }
    },

    initialize: function (canvas, config, idx) {
      Module.prototype.initialize.apply(this, arguments);
      var self = this;
      if (config.data && config.data.model && config.data.model.series && config.data.model.year) {
        self.series = config.data.model.series;
        self.year = config.data.model.year;
        self.cacheId = 'vehicleInfo.' + self.series + '.' + self.year;
        self.requestDcr();

        PageCache.await(self.cacheId)
          .then(function (vehicleInfo) { self.drawPage(vehicleInfo); })
          .catch(function (err) { console.log('VI err: ', err); });
      }
    },

    requestDcr: function () {
      var cacheId = this.cacheId;
      var dcrFileName = this.year + '_' + this.series;
      if (this.getCanvas().getLang() === 'es') {
        dcrFileName += '_es';
      }
      var dcrPath = 'templatedata/BAT/VehicleInfoModules/data/' + dcrFileName + '.xml';

      if (!PageCache.has(cacheId) && !PageCache.isPending(cacheId)) {
        PageCache.maybeSet(
          cacheId,
          lscs.dcr().fetch({ path: dcrPath }).then(__xformVehicleInfo)
        );
      }
    },

    drawPage: function (vehicleInfo) {
      this.staticData.all = Object.assign({}, this.staticData.all, vehicleInfo);
      this.setTemplate(__tmplBody);
      // only needs to happen on 2 & 3 wide modules. at least so far! And not on real mobile devices
      if (this._config.width !== 1 && !__isMobile) {
        this.$el.find('.module-headline').textFit({
          widthOnly: true,
          maxFontSize: 36,
          minFontSize: 31,
          multiLine: true
        });
      }
    },

    getTemplateContext: function () {
      this.staticData.en.actions = [{
        title: 'Get Started',
        url: '/' + tdaConfig.site.context_url + '/vehicles/' + __buildSeriesPath(this.series, this.year)
      }];

      this.staticData.es.actions = [{
        title: 'Empieza',
        url: '/' + tdaConfig.site.context_url + '/vehicles/' + __buildSeriesPath(this.series, this.year)
      }];

      // console.log('Obj for VI HBS: ', this.staticData)
      var ctx = $.extend({}, this.staticData.all, this.staticData[this.getCanvas().getLang()], this.getConfig().data);
      return ctx;
    },


  });

  return VehicleInfoSpecificModule;
});

